<template>
  <div>
    <div v-if="profile">
      <div class="row mb-4">
        <div class="col s12">
          <label for="pageName">{{ $t('Page name') }}</label>
        </div>
        <div class="col s12">
          <h3>{{ profile.pagename }}</h3>
        </div>
      </div>

      <div v-if="$store.state.shoptheme.includes(selectedBot.theme)" class="row mb-4">
        <div class="col s12">
          <label for="pageShortLink">{{ $t('Page short link') }}</label>
          <!-- <a href="javascript:void(0);" @click="resetPageShortLink" v-if="isEdit">
            <em class="fas fa-redo-alt"/>
          </a> -->
        </div>

        <div
          class="col s12 form-control"
          :class="{ 'has-error': errors.has('pageShortLinkInput') }"
        >
          <!-- <div v-if="isEdit">
            <!-- <tooltip v-model="showSaveShortlink">Saved</tooltip> ->
            <span>https://shopv2.zwiz.app/ecommerce/</span>
            <input
              style="display: inline-block; min-width: 200px; width: auto"
              class="form-control"
              v-model="profile.pageshortlink"
              name="pageShortLinkInput"
              :data-vv-as="$t('Page short link')"
              @change="isChangeShortlink = true"
              v-validate="'required|alpha_dash'"
            />
            <div>
              <span class="text-error" v-show="errors.has('pageShortLinkInput')">{{
                errors.first('pageShortLinkInput')
              }}</span>
            </div>
          </div> -->
          <p style="overflow: auto">
            <a target="BLANK" :href="`https://shopcommu.zwiz.app/ecommerce/${pageid}`">
              <template v-if="profile.pageshortlink && profile.pageshortlink != ''">{{
                `https://shopcommu.zwiz.app/ecommerce/${profile.pageshortlink}`
              }}</template>
              <template v-else>{{ `https://shopcommu.zwiz.app/ecommerce/${pageid}` }}</template>
            </a>
          </p>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col s12">
          <label>
            {{ $t('Shop Color') }}
            <v-premium-lock :inline="true"></v-premium-lock>
          </label>
          <template v-if="isEdit && $store.getters.getPackage == 'premium'">
            <swatches
              v-model="profile.shopcolor"
              show-fallback
              fallback-input-type="color"
            ></swatches>
          </template>
          <template v-else>
            <div
              style="width: 50px; height: 50px; border-radius: 10px"
              :style="{ background: profile.shopcolor }"
            ></div>
          </template>
        </div>
      </div>
      <div class="row mb-4">
        <div class="col s12">
          <div>
            <label>
              {{ $t('Shop Language') }}
              <v-premium-lock :inline="true"></v-premium-lock>
            </label>
          </div>
          <div class="mb-3">
            <template v-if="isEdit && $store.getters.getPackage == 'premium'">
              <multiselect
                v-model="profile.shoplang"
                :options="langOptions"
                label="label"
                :allow-empty="false"
                :searchable="false"
                select-label
                selected-label
                deselect-label
                track-by="label"
                @select="onSelectLang"
              ></multiselect>
            </template>
            <div v-else class="primary-color">{{ profile.shoplang.label }}</div>
          </div>
        </div>
      </div>

      <div v-if="$store.state.shoptheme.includes(selectedBot.theme)" class="row mb-4">
        <div class="col s12">
          <label for="Company Name">{{ $t(`Company Name`) }}</label>
        </div>
        <div class="col s12 form-control">
          <!-- <div v-if="isEdit">
            <input
              v-model="profile.companyname"
              class="form-control"
              style="resize: vertical"
              type="text"
            />
          </div> -->
          <div>{{ profile.companyname ? profile.companyname : '-' }}</div>
        </div>
      </div>

      <div
        v-if="showAddress && $store.state.shoptheme.includes(selectedBot.theme)"
        class="row mb-4"
      >
        <div class="col s12">
          <label for="pageAddress">{{ $t('Shop address') }}</label>
        </div>
        <div class="col s12 form-control">
          <!-- <div v-if="isEdit">
            
            <textarea
              v-model="profile.pageaddress"
              class="form-control"
              rows="5"
              style="resize: vertical"
              @change="isChangeAddress = true"
            ></textarea>
          </div> -->
          <div>{{ profile.pageaddress ? profile.pageaddress : '-' }}</div>
        </div>
      </div>
      <div v-if="$store.state.shoptheme.includes(selectedBot.theme)" class="row mb-4">
        <div class="col s12">
          <label for="Company Name">{{ $t(`Company Name`) }}</label>
        </div>
        <div class="col s12 form-control">
          <div v-if="isEdit">
            <input
              v-model="profile.companyname"
              class="form-control"
              style="resize: vertical"
              type="text"
            />
          </div>
          <div v-else>{{ profile.companyname ? profile.companyname : '-' }}</div>
        </div>
      </div>
      <div v-if="$store.state.shoptheme.includes(selectedBot.theme)" class="row mb-4">
        <div class="col s12">
          <label for="Telephone Number">{{ $t(`Tel.`) }}</label>
        </div>
        <div class="col s12 form-control">
          <!-- <div v-if="isEdit">
            <input
              v-model="profile.phoneno"
              class="form-control"
              style="resize: vertical"
              type="number"
            />
          </div> -->
          <div>{{ profile.phoneno ? profile.phoneno : '-' }}</div>
        </div>
        <div class="col s12 pt-4">
          <span class="red-text">*** {{ $t('You can edit your shop address at ') }}</span
          ><a
            :href="'/' + currentLang + '/template?tab=ShippingMethod'"
            style="text-decoration: underline"
            >{{ $t('SHIPPING METHOD or click here') }}</a
          >
        </div>
      </div>

      <div class="row text-xs-center">
        <div class="col s12">
          <template v-if="isEdit">
            <v-btn outline color="grey" @click="cancelEdit">{{ $t('cancel') }}</v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              depressed
              color="primary"
              @click="saveContent"
              >{{ $t('Save') }}</v-btn
            >
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import axios from 'axios'
import config from '@/config'
import api from '@/api'
import Tooltip from '@/components/elements/Tooltip'
import Swatches from 'vue-swatches'
import 'vue-swatches/dist/vue-swatches.min.css'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Tooltip,
    Swatches,
    Multiselect
  },
  props: {
    isEdit: undefined,
    showAddress: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      profile: null,
      loading: false,
      lang: {
        value: 'th',
        flag: 'th',
        label: 'Thai'
      },
      color: '#1CA085',
      oldProfile: null,
      langOptions: [
        {
          value: 'en',
          flag: 'gb',
          label: 'English'
        },
        {
          value: 'th',
          flag: 'th',
          label: 'Thai'
        },
        {
          value: 'la',
          flag: 'la',
          label: 'Laos'
        }
      ],
      showSaveShortlink: false,
      showSaveDescription: false,
      showSaveAddress: false,

      isChangeShortlink: false,
      isChangeDescription: false,
      isChangeAddress: false
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      botlist: 'botlist',
      currentLang: 'currentLang'
    }),
    pageid: function () {
      if (!this.$store.state.selectedBot) {
        return null
      }
      return this.$store.state.selectedBot.pageid
    }
  },
  mounted: function () {
    this.getShopProfile()
  },
  methods: {
    onSelectLang: function (val) {
      this.lang = val
      this.profile.shoplang = val.value
    },
    getShopProfile: function () {
      if (!this.pageid || this.pageid == null) {
        return false
      }
      let data = {
        pageid: this.pageid
      }
      let vm = this
      api.getShopProfile(data, function (error, response) {
        if (error) {
          console.error(error)

          return
        }
        if (response.shopprofile) {
          var description
          try {
            if (response.shopprofile.description) {
              description = JSON.parse(response.shopprofile.description)
            } else {
              description = { phoneno: '', companyname: '' }
            }
          } catch (error) {
            description = { phoneno: '', companyname: '' }
          }
          var profile = {
            pageaddress: response.shopprofile.pageaddress,
            description: response.shopprofile.description,
            pageshortlink: response.shopprofile.pageshortlink,
            pagename: response.shopprofile.pagename,
            shopcolor: response.shopprofile.shopcolor,
            shoplang: vm.langOptions.find((el) => el.value == response.shopprofile.shoplang),
            phoneno: description.phoneno ? description.phoneno : '',
            companyname: description.companyname ? description.companyname : ''
          }
          vm.profile = { ...profile }
          vm.oldProfile = { ...profile }
        }
      })
    },
    resetPageShortLink: function () {
      if (!this.pageid || this.pageid == null) {
        return false
      }
      this.isChangeShortlink = true
      this.profile.pageshortlink = this.pageid
    },
    cancelEdit: function () {
      this.profile = { ...this.oldProfile }
      this.$emit('onSave')
    },
    saveContent: function () {
      let vm = this
      vm.loading = true
      if (!vm.pageid || vm.pageid == null) {
        return false
      }
      let data = {
        description: vm.profile.description != null ? vm.profile.description : '',
        pageaddress: vm.profile.pageaddress != null ? vm.profile.pageaddress : '',
        pageid: vm.pageid,
        pageshortlink: vm.profile.pageshortlink != null ? vm.profile.pageshortlink : vm.pageid,
        shopcolor: vm.profile.shopcolor,
        shoplang: vm.profile.shoplang.value
      }
      data.description = JSON.stringify({
        companyname: vm.profile.companyname,
        phoneno: vm.profile.phoneno
      })

      vm.$validator.validate().then((result) => {
        if (!result) {
          // do stuff if not valid.
          vm.goToErrorInput()
          return false
        }
        // if (vm.isChangeShortlink || vm.isChangeDescription || vm.isChangeAddress) {

        api.editShopProfile(data, function (error, response) {
          vm.loading = false
          if (error) {
            console.error(error)
            return
          }
          vm.$emit('onSave')
          vm.$store.state.pageProfile = data
          vm.oldProfile.description = vm.profile.description
          vm.oldProfile.pageaddress = vm.profile.pageaddress
          vm.oldProfile.pageshortlink = vm.profile.pageshortlink
          // switch (type) {
          //     case 'shortlink':
          //         vm.showSaveShortlink = true
          //         break;
          //     case 'description':
          //         vm.showSaveDescription = true
          //         break;
          //     case 'address':
          //         vm.showSaveAddress = true
          //         break;
          // }
          // vm.isChangeShortlink = false
          // vm.isChangeDescription = false
          // vm.isChangeAddress = false
        })
        // }
      })
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/setting/ecommerce/ShopProfile.vue